import gql from 'graphql-tag';

const NAME =
  'compositions_CaseDealerLocatorPanel_updateAssetLocationNoteMutation';

export default gql`
  mutation ${NAME} (
    $assetLocationNote: String!,
    $id: ID!,
  ) {
    updateCase(
      input: {
        id: $id,
        patch: {
          assetLocation: {
            note: $assetLocationNote
          }
        },
      },
    ) {
      case {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseDealerLocatorPanel/updateAssetLocationNoteMutation.js